export default __webpack_public_path__ + "static/media/arrow-up.65164624.svg";